export default [
    {
        id: 1,
        name: 'Wildness',
        other: 'Dusted Digga',
        titel: 5
    },
    {
        id: 2,
        name: 'Bubbles',
        other: 'Melo',
        titel: 2
    },
    {
        id: 3,
        name: 'Into The Wild',
        other: 'Payy',
        titel: 3
    },
    {
        id: 4,
        name: 'Kobination',
        other: 'Bligg',
        titel: 1
    },
    {
        id: 5,
        name: 'Albert Hoffmann',
        other: 'Dusted Digga',
        titel: 5
    },
    {
        id: 6,
        name: 'Wildness',
        other: 'Dusted Digga',
        titel: 5
    },
    {
        id: 7,
        name: 'Bubbles',
        other: 'Melo',
        titel: 2
    },
    {
        id: 8,
        name: 'Into The Wild',
        other: 'Payy',
        titel: 3
    },
    {
        id: 9,
        name: 'Kobination',
        other: 'Bligg',
        titel: 1
    },
    {
        id: 10,
        name: 'Albert Hoffmann',
        other: 'Dusted Digga',
        titel: 5
    }]



// WEBPACK FOOTER //
// ./src/data/alle_release.js